import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name:'Usernametag'})
export class Usernametag implements PipeTransform{
	transform(value): string{
		
		const words = value.split('_');

		let word = '';

		for (var i = 0; i < words.length - 1; i++) {
			word = word +' '+words[i];
		}

		//console.log(word);
		
		//return words[0]+' '+words[1];
		return word;

	}
}